type MMVFormat = 'internal' | 'path';

//Make model and variant names are formatted with underscores in the backend and as filter values in this app
//however in URL paths they need to be formatted with hyphens instead

//NOTE: This should NOT be used on compound model or variant ids e.g. ford-s_max or ford-focus-st_line
//first getModelNameFromId() or getVariantNameFromId() to strip away unwanted parts

export const formatMMV = (id: string, requestedFormat: MMVFormat) => {
  if (requestedFormat === 'internal') return id.replaceAll('-', '_');
  if (requestedFormat === 'path') return id.replaceAll('_', '-');
  return id;
};
